import React, { useState, createContext } from 'react';
import { ConfigProvider as AntProvider } from 'antd';
import deDe from 'antd/lib/locale/de_DE';

import { IntlProvider, getLocale } from '../../i18n';
import { defaultLocale } from '../../i18n/config';

const LanguageContext = createContext({});

interface ILanguageProvider {
  children: any;
}

export const LanguageProvider = ({ children }: ILanguageProvider) => {
  const localeData = getLocale(defaultLocale);
  const [lang, setLang] = useState(localeData.locale);

  return (
    <IntlProvider
      defaultLocale={defaultLocale}
      key={lang}
      locale={lang}
      messages={localeData.messages}
    >
      <AntProvider locale={deDe}>
        <LanguageContext.Provider
          value={{
            setAppLanguage: setLang,
          }}
        >
          {children}
        </LanguageContext.Provider>
      </AntProvider>
    </IntlProvider>
  );
};
